/** Public domain for client-facing signature links (masked via Cloudflare). */
export const SIGN_PUBLIC_ORIGIN = "https://getlegalpal.com";

/** WordPress / media origin (APIs, ajax, assets). */
export const QIX_ORIGIN = "https://qix.cloud";

/**
 * Build a shareable signature URL on getlegalpal.com
 * e.g. https://getlegalpal.com/s/6768
 */
export function buildSignUrl(id) {
  const cleanId = String(id ?? "").replace(/^\/+|\/+$/g, "");
  return `${SIGN_PUBLIC_ORIGIN}/s/${cleanId}`;
}

/**
 * If a backend still returns a qix.cloud/s/... link, rewrite it for sharing.
 */
export function toPublicSignUrl(url) {
  if (!url) return url;
  return String(url)
    .replace(/^https?:\/\/(www\.)?qix\.cloud\/s\//i, `${SIGN_PUBLIC_ORIGIN}/s/`)
    .replace(/^https?:\/\/(www\.)?qix\.cloud\/sv\//i, `${SIGN_PUBLIC_ORIGIN}/sv/`);
}
